<template>
    <el-card
        class="material-index relative"
        :class="{ 'pages-height': ['first', 'second'].includes(activeName) }">
        <!-- 除去最后的跟进记录 -->
        <div class="flex common-operation" v-if="activeName !== 'eighth'">
            <el-tooltip
                effect="dark"
                :content="activeName === 'third' ? $t('Common.distribution_saler') : $t('Common.distribution_coach')"
                placement="bottom"
                v-if="['third', 'sixth'].includes(activeName)">
                <el-button
                    class="el-button-ui iconfont icon-fitness-fenpei"
                    @click="handleAssign"
                ></el-button>
            </el-tooltip>
            <el-tooltip
                effect="dark"
                :content="$t('Common.follow-up')"
                placement="bottom"
                v-if="['forth', 'seventh', 'fifth'].includes(activeName)">
                <el-button
                    class="el-button-ui iconfont icon-fitness-kehugenjin"
                    @click="follow"
                ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" :content="$t('tooltip.check')" placement="bottom">
                <el-button
                    class="el-button-ui iconfont icon-fitness-yanjing2"
                    @click="handleShow"
                ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" :content="$t('tooltip.edit')" placement="bottom">
                <el-button
                    class="iconfont icon-fitness-icon-test-copy-copy-copy-copy-copy-copy-copy-copy-copy el-button-ui"
                    @click="handleEdit"
                ></el-button>
            </el-tooltip>

            <!-- 会员 -->
            <template v-if="activeName === 'first' || activeName === 'second'">
                <el-tooltip effect="dark" :content="$t('Common.member_side')" placement="bottom">
                    <el-button @click="measurement()" class="el-button-ui iconfont icon-fitness-neicezhangdan-"/>
                </el-tooltip>
                <el-tooltip effect="dark" :content="$t('Common.must_exercise_data')" placement="bottom">
                    <el-button class="el-button-ui iconfont icon-fitness-xinlv"/>
                </el-tooltip>
            </template>

            <el-tooltip
                effect="dark"
                :content="clientIds.length > 1 ? $t('Common.delete—in-batches') : $t('tooltip.delete')"
                placement="bottom">
                <el-button
                    class="el-button-ui iconfont icon-fitness-shanchu"
                    @click="handleDelete()"
                ></el-button>
            </el-tooltip>
            <el-tooltip
                effect="dark"
                :content="clientIds.length > 1 ? $t('Common.recover—in-batches') : $t('tooltip.refresh')"
                placement="bottom">
                <el-button
                    class="el-button-ui iconfont icon-fitness-huifu1"
                    @click="handleRestore()"
                ></el-button>
            </el-tooltip>

        </div>
        <div class="search">
            <el-tooltip effect="dark" :content="$t('Common.new_customer')" placement="bottom">
                <el-button
                    class="el-button-ui iconfont icon-fitness-unie612 top-icon"
                    @click="handleAdd()"
                ></el-button>
            </el-tooltip>
            <template v-if="activeName === 'first' || activeName === 'second'">
                <el-tooltip effect="dark" :content="$t('Common.screen')" placement="bottom">
                    <el-button
                        class="el-button-ui iconfont icon-fitness-shaixuan top-icon"
                        @click="handleFind()">
                    </el-button>
                </el-tooltip>
                <el-tooltip
                    effect="dark"
                    :content="$t('tooltip.import')"
                    placement="bottom">
                    <el-button
                        @click="handleExport()"
                        class="el-button-ui iconfont icon-fitness-shangchuan top-icon">
                    </el-button>
                </el-tooltip>
            </template>
        </div>
        <!-- 筛选条件 -->
        <div
            v-if="is_collapse"
            class="filter_panel"
            v-clickoutside="handleClose">
            <div style="height: 100%;overflow-y: auto;">
                <div class="filter-show_all">
                    <div class="box-a1 filter-pages-fixed">
                        <p>{{ $t('Client.type') }}</p>
                        <p>{{ activeName === 'first' ? $t('Common.prospective_customer') : $t('Common.full_member') }}</p>
                    </div>
                    <div v-for="(item, index) in request" :key="index">
                        <div
                            class="box-a1"
                            v-if="key === item.value && value !== '' && value !== null && key !== 'clientTagIds' && key !== 'clientIds' && key !== 'contractStoreIds'"
                            v-for="(value, key, index) in tableData" :key="index">
                            <p>{{ item.name }}</p>
                            <i class="el-icon-close delete-property" @click="removeOption(value, key, index)"/>
                            <p
                                v-if="item.option && count.code === value"
                                v-for="(count, cIndex) in item.option"
                                :key="cIndex"
                            >{{ count.name }}</p>
                            <p v-if="!item.option">{{ value }}</p>
                        </div>
                    </div>
                    <!-- 数组 -->
                    <div v-if="form.clientTagIds && form.clientTagIds.length" class="box-a1">
                        <p>{{ $t('Client.Add.customer_label') }}</p>
                        <i class="el-icon-close delete-property" @click="form.clientTagIds = tableData.clientTagIds = []"/>
                        <div class="filter-tags-flex" v-for="(tip, key) in tag" :key="key">
                            <p
                                v-for="(choose, cIndex) in form.clientTagIds"
                                :key="cIndex"
                                v-if="tip.id === choose">
                                {{ tip.name }}{{ cIndex === form.clientTagIds.length - 1 ? '' : '，'}}
                            </p>
                        </div>
                    </div>
                    <div v-if="form.contractStoreIds && form.contractStoreIds.length" class="box-a1">
                        <p> 会籍合同签约门店 </p>
                        <i class="el-icon-close delete-property" @click="form.contractStoreIds = tableData.contractStoreIds = []"/>
                        <div
                            class="filter-tags-flex"
                            v-for="(tip, key) in request[request.length - 1].option"
                            :key="key">
                            <!-- {{ tip, key }} -->
                            <!-- tip: {{ tip }} <br />
                            key: {{ key }} -->
                            <p
                                v-for="(choose, cIndex) in form.contractStoreIds"
                                :key="cIndex"
                                v-if="tip.id === choose">
                                <!-- {{ tip.id }} <br /> -->
                                <!-- choose {{ choose }} -->
                                {{ tip.name }}{{ cIndex === form.contractStoreIds.length - 1 ? '' : '，'}}
                            </p>
                        </div>
                    </div>

                    <div v-show="date.length" class="box-a1">
                        <p>{{ $t('Client.entry_date') }}</p>
                        <i class="el-icon-close delete-property" @click="date = []"/>
                        <p>{{ date[0] }}——{{ date[1] }}</p>
                    </div>
                    <div v-show="birthday.length" class="box-a1">
                        <p>{{ $t('Common.birthday') }}</p>
                        <i class="el-icon-close delete-property" @click="birthday = []"/>
                        <p>{{ birthday[0] }}——{{ birthday[1] }}</p>
                    </div>
                    <template>
                        <el-button
                            type="warning"
                            style="margin-left:30px"
                            @click.prevent="addSearch = !addSearch">
                            {{ $t('Common.add_search') }}
                        </el-button>
                        <el-button
                            type="primary"
                            style="margin:10px"
                            @click="handleQuery()"
                        >{{ $t('Common.search') }}</el-button>
                        <el-button @click="handleReset" style="margin-left:0px">{{ $t('Common.clear') }}</el-button>
                    </template>
                </div>
            </div>
            <div v-if="addSearch" class="filter_panel1" v-show="addSearch">
                <el-form
                    :model="form"
                    label-position="right"
                    style="margin: 10px"
                    class="w-full flex flex-wrap items-center"
                >
                    <el-form-item class="w-1/5.5">
                        <el-select
                            v-model="query"
                            :placeholder="$t('Common.screening_condition')"
                            class="w-full"
                            clearable>
                            <el-option
                                v-for="(item, index) in request"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="query === 'mshpSalesId'">
                        <el-input
                        v-model="form.mshpSalesId"
                        :placeholder="$t('Common.please_import_id')"
                        class="w-full"
                        clearable
                        />
                    </el-form-item>
                    <el-form-item v-if="query === 'active'">
                        <el-select v-model="form.active" :placeholder="$t('Common.member_status')" class="w-full" clearable>
                            <el-option
                                v-for="(item, index) in request[2].option"
                                :key="index"
                                :label="item.name"
                                :value="item.code"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="query === 'contractStoreIds'">
                        <el-select
                            multiple
                            v-model="form.contractStoreIds"
                            placeholder="请选择门店"
                            class="w-full" clearable>
                            <el-option
                                v-for="(item, index) in request[request.length - 1].option"
                                :key="index"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item class="el-input--small" v-if="query === 'createdAt'">
                        <el-date-picker
                            v-model="date"
                            style="width: 280px"
                            type="daterange"
                            range-separator="-"
                            :start-placeholder="$t('Common.choose_date')"
                            :end-placeholder="$t('Common.choose_date')"
                            value-format="yyyy-MM-dd"
                        />
                    </el-form-item>
                    <el-form-item v-if="query === 'editorId'">
                        <el-input v-model="form.editorId"
                         :placeholder="$t('Common.please_import_staffID')"
                          class="w-full" clearable
                          />
                    </el-form-item>
                    <el-form-item v-if="query === 'categoryCode'">
                        <el-select v-model="form.categoryCode"
                        :placeholder="$t('Common.select_customer_classify')"
                        class="w-full" clearable
                        >
                            <el-option
                                v-for="(item, index) in request[4].option"
                                :key="index"
                                :label="item.name"
                                :value="item.code"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="query === 'clientTagIds'">
                        <el-select
                            v-model="form.clientTagIds"
                            multiple
                            :placeholder="$t('Common.select_customer_label')"
                            class="w-full"
                            clearable>
                            <el-option
                                v-for="(item, index) in tag"
                                :key="index"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="query === 'followLevelCode'">
                        <el-select
                            v-model="form.followLevelCode"
                            :placeholder="$t('Client.Add.follow_level_placeholder')"
                            class="w-full"
                            clearable>
                            <el-option
                                v-for="(item, index) in request[6].option"
                                :key="index"
                                :label="item.name"
                                :value="item.code"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="query === 'channelSourceCode'">
                        <el-select
                            v-model="form.channelSourceCode"
                            :placeholder="$t('Client.Add.get_attributes_placeholder')"
                            class="w-full"
                            clearable
                        >
                            <el-option
                                v-for="(item, index) in request[7].option"
                                :key="index"
                                :label="item.name"
                                :value="item.code"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="query === 'channelAttrCode'">
                            <el-select
                            v-model="form.channelAttrCode"
                            :placeholder="$t('Client.Add.attributes_placeholder')"
                            class="w-full"
                            clearable>
                            <el-option
                                v-for="(item, index) in request[8].option"
                                :key="index"
                                :label="item.name"
                                :value="item.code"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="query === 'age'">
                        <el-input v-model="form.age" :placeholder="$t('Common.age')" class="w-full" clearable/>
                    </el-form-item>
                    <el-form-item v-if="query === 'genderCode'">
                        <el-select v-model="form.genderCode" :placeholder="$t('Common.gender_placeholder')" class="w-full" clearable>
                            <el-option :label="$t('Common.male')" :value="1"/>
                            <el-option :label="$t('Common.female')" :value="2"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="el-input--small" v-if="query === 'birthday'">
                        <el-date-picker
                            v-model="birthday"
                            style="width: 280px"
                            type="daterange"
                            range-separator="-"
                            :start-placeholder="$t('Common.choose_date')"
                            :end-placeholder="$t('Common.choose_date')"
                            value-format="yyyy-MM-dd"
                        />
                    </el-form-item>
                    <el-form-item v-if="query === 'hasAvatar'">
                        <el-select v-model="form.hasAvatar" :placeholder="$t('Common.picture')" class="w-full" clearable>
                            <el-option :label="$t('Common.yes')" :value="true"/>
                            <el-option :label="$t('Common.no')" :value="false"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="query === 'marriageCode'">
                        <el-select v-model="form.marriageCode" :placeholder="$t('Common.marital_status')" class="w-full" clearable>
                            <el-option
                                v-for="(item, index) in request[13].option"
                                :key="index"
                                :label="item.name"
                                :value="item.code"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="query === 'childrenCode'">
                        <el-select v-model="form.childrenCode" placeholder="$t(Common.sons_and_daughters)" class="w-full" clearable>
                            <el-option
                                v-for="(item, index) in request[14].option"
                                :key="index"
                                :label="item.name"
                                :value="item.code"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="query === 'infoHabitCode'">
                        <el-select
                            v-model="form.infoHabitCode"
                            :placeholder="$t('Common.consult_approach')"
                            class="w-full"
                            clearable>
                            <el-option
                                v-for="(item, index) in request[15].option"
                                :key="index"
                                :label="item.name"
                                :value="item.code"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="query === 'personalHobbyCode'">
                        <el-select
                            v-model="form.personalHobbyCode"
                            :placeholder="$t('Common.personal_preference')"
                            class="w-full"
                            clearable>
                            <el-option
                                v-for="(item, index) in request[16].option"
                                :key="index"
                                :label="item.name"
                                :value="item.code"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="query === 'joinedClubCode'">
                        <el-select
                            v-model="form.joinedClubCode"
                            :placeholder="$t('Client.Add.club')"
                            class="w-full"
                            clearable>
                            <el-option :label="$t('Common.please_choose')" :value="-1"/>
                            <el-option :label="$t('Common.yes')" :value="1"/>
                            <el-option :label="$t('Common.no')" :value="0"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="query === 'joinedClubBrand'">
                        <el-input
                            v-model="form.joinedClubBrand"
                            :placeholder="$t('Common.Along_with_city')"
                            class="w-full"
                            clearable
                        />
                    </el-form-item>
                    <el-form-item v-if="query === 'fitnessPurposeCode'">
                        <el-select
                            v-model="form.fitnessPurposeCode"
                            :placeholder="$t('Client.Add.purpose_placeholder')"
                            class="w-full"
                            clearable>
                            <el-option
                                v-for="(item, index) in constant[fitnessPurpose]"
                                :key="index"
                                :label="item.name"
                                :value="item.code"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="query === 'wasFitnessMemberCode'">
                        <el-select
                            v-model="form.wasFitnessMemberCode"
                            :placeholder="$t('Common.please_choose')"
                            class="w-full"
                            clearable>
                            <el-option
                                v-for="(item, index) in request[20].option"
                                :key="index"
                                :label="item.name"
                                :value="item.code"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="query === 'leftReasonCode'">
                        <el-select v-model="form.leftReasonCode" :placeholder="$t('Client.Add.leave_reason_placeholder')" class="w-full" clearable>
                            <el-option
                                v-for="(item, index) in request[21].option"
                                :key="index"
                                :label="item.name"
                                :value="item.code"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="query === 'keyword'">
                        <el-input v-model="form.keyword" :placeholder="$t('Common.employee_message')" class="w-full" clearable/>
                    </el-form-item>
                    <el-form-item style="width:200px" label-width="20px">
                        <el-button type="primary" @click="addQuery">{{ $t('Message.confirm') }}</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
                :label="$t('Common.potential_customer_manage')"
                name="first"
                v-if="$$filterPermission('客户-潜在客户查看-仅查看分配给自己的')
                || $$filterPermission('客户-潜在客户查看-可查看全部')
                || $$filterPermission('客户-客户/会员管理-查看并编辑')">
                <potential-client
                    :activeName.sync="activeName"
                    ref="potential"
                    :clientId="clientId"
                    :formData.sync="this.tableData"
                    :ids="clientIds"
                    v-on:listenClientIds="headListen"
                    v-model="input">
                </potential-client>
            </el-tab-pane>
            <el-tab-pane
                :label="$t('Common.member_management')"
                name="second"
                v-if="$$filterPermission('客户-会员查看-仅查看分配给自己的')
                || $$filterPermission('客户-客户/会员管理-查看并编辑')
                || $$filterPermission('客户-会员查看-可查看全部')">
                <full-member
                    :activeName="activeName"
                    ref="full"
                    :clientId="clientId"
                    :formData.sync="this.tableData"
                    :ids="clientIds"
                    v-on:listenClientIds="headListen"
                    v-model="input">
                </full-member>
            </el-tab-pane>
            <el-tab-pane
                v-if="$$filterPermission('客户-分配会籍销售-分配会籍销售')"
                :label="$t('Common.distribution_saler')"
                name="third">
                <assign-sale
                    ref="assignSale"
                    :activeName="activeName"
                    :ids="clientIds"
                    v-on:listenClientIds="headListen"
                    v-model="input">
                </assign-sale>
            </el-tab-pane>
            <el-tab-pane
                v-if="$$filterPermission('客户-会籍销售跟进潜在客户-客户列表仅查看分配给自己的')
                || $$filterPermission('客户-会籍销售跟进潜在客户-客户列表可查看全部')"
                :label="$t('Common.membership_to_potentialCustomer')"
                name="forth">
                <sales-follow-potential
                    :activeName="activeName"
                    ref="followPo"
                    :ids="clientIds"
                    v-on:listenClientIds="headListen"
                    v-model="input">
                </sales-follow-potential>
            </el-tab-pane>
            <el-tab-pane
                v-if="$$filterPermission('客户-会籍销售跟进正式会员-客户列表仅查看分配给自己的')
                || $$filterPermission('客户-会籍销售跟进正式会员-客户列表可查看全部')"
                :label="$t('Common.MembershipSales_to_member')"
                name="fifth">
                <sales-follow-full
                    :activeName="activeName"
                    ref="followFull"
                    :ids="clientIds"
                    v-on:listenClientIds="headListen"
                    v-model="input">
                </sales-follow-full>
            </el-tab-pane>
            <el-tab-pane
                :label="$t('Common.distribution_coach')"
                v-if="$$filterPermission('客户-分配教练-分配教练')"
                name="sixth">
                <assign-coach
                    :activeName="activeName"
                    ref="coach"
                    :ids="clientIds"
                    v-on:listenClientIds="headListen"
                    v-model="input">
                </assign-coach>
            </el-tab-pane>
            <el-tab-pane
                v-if="$$filterPermission('客户-教练跟进正式会员-客户列表仅查看分配给自己的')
                || $$filterPermission('客户-教练跟进正式会员-客户列表可查看全部')"
                label="教练跟进会员"
                name="seventh">
                <coach-follow-full
                    :activeName="activeName"
                    ref="followCoach"
                    :ids="clientIds"
                    v-on:listenClientIds="headListen"
                    v-model="input">
                </coach-follow-full>
            </el-tab-pane>
            <el-tab-pane
                v-if="$$filterPermission('客户-跟进记录查看-查看自己的跟进记录')
                || $$filterPermission('客户-跟进记录查看-查看全部的跟进记录')"
                :label="$t('Common.followup_record')"
                name="eighth">
                <follow-record
                    :clientId.sync="clientId"
                    :activeName.sync="activeName"
                    ref="record"
                    v-model="input">
                </follow-record>
            </el-tab-pane>
        </el-tabs>
        <new-customer ref="newCustomer" v-model="input" @fetchData="fetchData" />
        <!--<follow-form ref="followForm" v-model="input"/>-->
        <show-follow ref="showFollow" v-model="input" @fetchData="fetchData" />
    </el-card>
</template>

<script>
import {
    Tooltip,
    Popover,
    DatePicker,
    Table,
    TableColumn,
    Pagination,
    Tag,
    Tabs,
    TabPane,
    OptionGroup,
    Dialog,
    CheckboxGroup,
    Checkbox,
    RadioGroup,
    Radio,
} from 'element-ui';
import NewCustomer from '@/components/Dialog/NewCustomer';
import PotentialClient from '@/components/TableCom/Client/PotentialClient';
import FullMember from '@/components/TableCom/Client/FullMember';
import AssignSale from '@/components/TableCom/Client/AssignSale';
import SalesFollowPotential from '@/components/TableCom/Client/SalesFollowPotential';
import SalesFollowFull from '@/components/TableCom/Client/SalesFollowFull';
import AssignCoach from '@/components/TableCom/Client/AssignCoach';
import CoachFollowFull from '@/components/TableCom/Client/CoachFollowFull';
import FollowRecord from '@/components/TableCom/Client/FollowRecord';
import FollowForm from '@/components/Dialog/FollowForm';
import ShowFollow from '@/components/Dialog/ShowFollow';
import cloneDeep from 'lodash/cloneDeep';

export default {
    name: 'client',
    components: {
        ShowFollow,
        Tooltip: Tooltip,
        Popover: Popover,
        ElDatePicker: DatePicker,
        ElTable: Table,
        ElTableColumn: TableColumn,
        ElPagination: Pagination,
        ElTag: Tag,
        ElTabs: Tabs,
        ElTabPane: TabPane,
        ElOptionGroup: OptionGroup,
        ElDialog: Dialog,
        ElCheckboxGroup: CheckboxGroup,
        ElCheckbox: Checkbox,
        ElRadioGroup: RadioGroup,
        ElRadio: Radio,
        NewCustomer,
        PotentialClient,
        FullMember,
        AssignSale,
        SalesFollowPotential,
        SalesFollowFull,
        AssignCoach,
        CoachFollowFull,
        FollowRecord,
        FollowForm,
    },
    data() {
        return {
            input: '',
            visible: false,
            addSearch: false,
            date: [],
            birthday: [],
            tag: [],
            tableData: {},
            clientIds: [],
            // clientId: null,
            clients: [],
            form: {
                mshpSalesId: '',
                createdAtStart: '',
                createdAtEnd: '',
                active: '',
                editorId: '',
                categoryCode: '',
                clientTagIds: [],
                followLevelCode: '',
                channelSourceCode: '',
                channelAttrCode: '',
                age: '',
                genderCode: '',
                birthdayStart: '',
                birthdayEnd: '',
                hasAvatar: '',
                marriageCode: '',
                childrenCode: '',
                infoHabitCode: '',
                personalHobbyCode: '',
                joinedClubCode: '',
                joinedClubBrand: '',
                fitnessPurposeCode: '',
                wasFitnessMemberCode: '',
                leftReasonCode: '',
                keyword: '',
                contractStoreIds: [],
            },
            request: [
                {
                    value: 'mshpSalesId',
                    name: this.$t('Common.Membership_staffID'),
                },
                {
                    value: 'createdAt',
                    name: this.$t('Client.entry_date'),
                },
                {
                    value: 'active',
                    name: this.$t('Common.member_status'),
                    option: [
                        {
                            code: true,
                            name: 'Reception.Fifth.normal',
                        },
                        {
                            code: false,
                            name: this.$t('Lesson.deleted'),
                        },
                    ],
                },
                {
                    value: 'editorId',
                    name: this.$t('Common.entering_employeeID'),
                },
                {
                    value: 'categoryCode',
                    name: this.$t('Client.Add.customer_type'),
                    option: [],
                },
                {
                    value: 'clientTagIds',
                    name: this.$t('Client.Add.customer_label'),
                },
                {
                    value: 'followLevelCode',
                    name: this.$t('Client.Add.follow_level'),
                    option: [],
                },
                {
                    value: 'channelSourceCode',
                    name: this.$t('Client.Add.get_attributes'),
                    option: [],
                },
                {
                    value: 'channelAttrCode',
                    name: this.$t('Client.Add.attributes'),
                    option: [],
                },
                {
                    value: 'age',
                    name: this.$t('Common.age')
                },
                {
                    value: 'genderCode',
                    name: this.$t('Common.gender'),
                    option: [],
                },
                {
                    value: 'birthday',
                    name: this.$t('Common.birthday'),
                },
                {
                    value: 'hasAvatar',
                    name: this.$t('Common.picture'),
                },
                {
                    value: 'marriageCode',
                    name: this.$t('Common.marrystatus'),
                    option: [],
                },
                {
                    value: 'childrenCode',
                    name: this.$t('Client.Add.child_situation'),
                    option: [],
                },
                {
                    value: 'infoHabitCode',
                    name: this.$t('Common.get_info_way'),
                    option: [],
                },
                {
                    value: 'personalHobbyCode',
                    name: this.$t('Client.Add.personal_hobby'),
                    option: [],
                },
                {
                    value: 'joinedClubCode',
                    name: this.$t('Client.Add.club'),
                    option: [
                        {
                            code: 0,
                            name: this.$t('Common.no'),
                        },
                        {
                            code: 1,
                            name: this.$t('Common.yes'),
                        },
                    ],
                },
                {
                    value: 'joinedClubBrand',
                    name: this.$t('Common.Along_with_the_city'),
                },
                {
                    value: 'fitnessPurposeCode',
                    name: this.$t('Client.Add.purpose'),
                    option: [],
                },
                {
                    value: 'wasFitnessMemberCode',
                    name: this.$t('Common.Former_member_club'),
                    option: [],
                },
                {
                    value: 'leftReasonCode',
                    name: this.$t('Client.Add.leave_reason'),
                    option: [],
                },
                {
                    value: 'clientIds',
                    name: this.$t('Card.client_id'),
                },
                {
                    value: 'keyword',
                    name: this.$t('Common.name_phone_card'),
                },
                {
                    value: 'contractStoreIds',
                    name: '会籍合同签约门店',
                    option: [],
                },
            ],
            query: '',
            rules: {},
            loading: false,
            is_collapse: false,
            editableTabs: [
                {
                    name: 'first',
                    isShow: this.$$filterPermission('客户-潜在客户查看-仅查看分配给自己的')
                    || this.$$filterPermission('客户-潜在客户查看-可查看全部')
                    || this.$$filterPermission('客户-客户/会员管理-查看并编辑'),
                }, {
                    name: 'second',
                    isShow: this.$$filterPermission('客户-会员查看-仅查看分配给自己的')
                    || this.$$filterPermission('客户-会员查看-可查看全部')
                    || this.$$filterPermission('客户-客户/会员管理-查看并编辑'),
                }, {
                    name: 'third',
                    isShow: this.$$filterPermission('客户-分配会籍销售-分配会籍销售'),
                }, {
                    name: 'fourth',
                    isShow: this.$$filterPermission('客户-会籍销售跟进潜在客户-客户列表仅查看分配给自己的')
                    || this.$$filterPermission('客户-会籍销售跟进潜在客户-客户列表可查看全部'),
                }, {
                    name: 'fifth',
                    isShow: this.$$filterPermission('客户-会籍销售跟进正式会员-客户列表仅查看分配给自己的')
                    || this.$$filterPermission('客户-会籍销售跟进正式会员-客户列表可查看全部'),
                }, {
                    name: 'sixth',
                    isShow: this.$$filterPermission('客户-分配教练-分配教练'),
                }, {
                    name: 'seventh',
                    isShow: this.$$filterPermission('客户-教练跟进正式会员-客户列表仅查看分配给自己的')
                    || this.$$filterPermission('客户-教练跟进正式会员-客户列表可查看全部'),
                }, {
                    name: 'eighth',
                    isShow: this.$$filterPermission('客户-跟进记录查看-查看自己的跟进记录')
                    || this.$$filterPermission('客户-跟进记录查看-查看全部的跟进记录'),
                },
            ],
        };
    },
    computed: {
        activeName: {
            get: function () {
                if (this.$route.query.activeName) return this.$route.query.activeName;
                return this.editableTabs.find(el => el.isShow).name;
            },
            set: function (newValue) {
                if (!this.clientId) return this.$router.replace({query: {activeName: newValue}});
                this.$router.replace({
                    query: {
                        activeName: newValue,
                        clientId: this.clientId,
                    }
                })
            }
        },
        clientId: {
            get: function () {
                if (this.$route.query.clientId) return this.$route.query.clientId;
                return null;
            },
            set: function (val) {},
        },
    },
    watch: {
        input(val) {
            if (val === 'update') this.fetchData();
        },
        '$route.query.activeName' (val) {
            this.activeName = val;
        },
    },
    methods: {
        fetchStore() {
            this.loading = true;
            API.get('store/list').then(res => {
                const index = this.request.length - 1;
                this.request[index].option = res;
            }).finally(() => {
                this.loading = false;
            });
        },
        handleFind() {
            if (this.$$filterPermission('客户-客户/会员管理-筛选')) this.is_collapse = !this.is_collapse;
            else {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
            }
        },
        handleClick(tab, event) {
            if (['first', 'second'].includes(tab.name)) {
                this.clientId = null;
                this.$router.replace({
                    name: 'Client',
                    query: {
                        activeName: tab.name,
                        clientId: null,
                    },
                });
            }
            if (this.is_collapse) this.is_collapse = false;
        },
        handleFlush() {
            switch (this.activeName) {
            case 'first':
                this.$refs.potential.fetchData();
                break;
            case 'second':
                this.$refs.full.fetchData();
                break;
            case 'third':
                this.$refs.assignSale.fetchData();
                break;
            case 'forth':
                this.$refs.followPo.fetchData();
                break;
            case 'fifth':
                this.$refs.followFull.fetchData();
                break;
            case 'sixth':
                this.$refs.coach.fetchData();
                break;
            case 'seventh':
                this.$refs.followCoach.fetchData();
                break;
            case 'eighth':
                this.$refs.record.fetchData();
                break;
            default:
                break;
            }
        },
        // 筛选条件搜索
        handleQuery() {
            if (this.birthday.length) {
                const birthdayDate = {
                    birthdayStart: this.birthday[0],
                    birthdayEnd: this.birthday[1],
                };
                this.tableData = Object.assign({}, this.tableData, birthdayDate);
            }
            if (this.date.length) {
                const createDate = {
                    createdAtStart: this.date[0],
                    createdAtEnd: this.date[1],
                };
                this.tableData = Object.assign({}, this.tableData, createDate);
            }
            const data = cloneDeep(this.tableData);
            if (this.activeName === 'first') {
                this.$refs.potential.say(data);
            } else {
                this.$refs.full.say(data);
            }
        },
        fetchData() {
            this.query = 'categoryCode';
            this.handleFlush();
        },
        handleAdd() {
            if (this.$$filterPermission('客户-客户/会员管理-添加客户资料')) this.$refs.newCustomer.open();
            else {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
            }
        },
        onSubmit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.postData();
                    this.visible = false;
                }
            });
        },
        addQuery() {
            this.tableData = this.form;
            this.addSearch = false;
        },
        fetchTag() {
            this.loading = true;
            API.get('client-tag/list', {
                active: true,
            }).then(res => {
                this.tag = res;
            }).finally(() => {
                this.loading = false;
            });
        },
        fetchConstant() {
            this.loading = true;
            API.get('constant/client', {
                active: true,
            }).then(res => {

                console.log(res);

                for (const prop in res) {
                    this.request.map(el => {
                        if (`${prop}Code` === el.value) el.option = res[prop];
                    });
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        // 重置
        handleReset() {
            this.date = [];
            this.birthday = [];
            this.tableData = {};
            this.form = {
                mshpSalesId: '',
                createdAtStart: '',
                createdAtEnd: '',
                active: '',
                editorId: '',
                categoryCode: '',
                clientTagIds: [],
                followLevelCode: '',
                channelSourceCode: '',
                channelAttrCode: '',
                age: '',
                genderCode: '',
                birthdayStart: '',
                birthdayEnd: '',
                hasAvatar: '',
                marriageCode: '',
                childrenCode: '',
                infoHabitCode: '',
                personalHobbyCode: '',
                joinedClubCode: '',
                joinedClubBrand: '',
                fitnessPurposeCode: '',
                wasFitnessMemberCode: '',
                leftReasonCode: '',
                clientIds: [],
                keyword: '',
                contractStoreIds: [],
            };
            if (this.activeName === 'first') this.$refs.potential.say(this.tableData);
            else this.$refs.full.say(this.tableData);
        },
        handleDelete() {
            if (!this.clientIds.length) {
                // return $ele.$message('至少选择一条客户信息');
                return $ele.$message(this.$t('Common.message.selectclientmsg'));
                console.log($ele);
            } else if (this.clientIds.length
            && this.$$filterPermission('客户-客户/会员管理-查看并删除或恢复客户资料')) {
                $ele.$confirm(this.$t('Common.message.affirmdelmsg'), this.$t('Common.tip'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    cancelButtonText: this.$t('Common.cancel'),
                    type: 'warning',
                })
                .then(() => {
                    API.delete('client/active', {
                        params: {
                            ids: this.clientIds.join(','),
                        },
                    }).then(() => {
                        $ele.$message.success(this.$t('Message.delete_success'));
                        this.fetchData();
                    });
                })
                .catch(() => {
                    $ele.$message.info(this.$t('Common.message.canceldel'));
                });
            } else {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
            }
        },
        handleRestore() {
            if (!this.clientIds.length) {
                return $ele.$message(this.$t('Common.message.selectclientmsg'));
            } else if (this.clientIds.length
            && this.$$filterPermission('客户-客户/会员管理-查看并删除或恢复客户资料')) {
                $ele.$confirm(this.$t('Common.message.restoreclientmsg'), this.$t('Common.tip'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    cancelButtonText: this.$t('Common.cancel'),
                    type: 'warning',
                }).then(() => {
                    API.put(
                        '/client/active',
                        {}, {
                            params: {
                                ids: this.clientIds.join(','),
                            },
                        }
                    ).then(() => {
                        $ele.$message.success(this.$t('Common.message.successRestore'));
                        this.fetchData();
                    });
                }).catch(() => {
                    $ele.$message.info(this.$t('Common.message.cancelRestore'));
                });
            } else {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
            }
        },
        handleShow() {
            if (this.validSingleSelect()) {
                this.$router.push({
                    name: 'Client.Show',
                    params: {
                        id: this.clientIds[0],
                        activeName: this.activeName,
                    },
                });
            }
        },
        handleEdit() {
            if (this.validSingleSelect()) {
                if (this.$$filterPermission('客户-客户/会员管理-查看并编辑')) {
                    this.$refs.newCustomer.open(this.clientIds[0]);
                } else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        follow() {
            if (this.validSingleSelect()) {
                let type = '';
                if (this.activeName === 'forth') type = 'potential';
                if (this.activeName === 'fifth') type = 'full';
                if (this.activeName === 'seventh') type = 'coach';
                this.$refs.showFollow.open(this.clients[0], type);
            }
        },
        handleAssign() {
            if (this.clientIds.length < 1) $ele.$message.warning(this.$t('Common.message.Pleaseselectone'));
            else if (this.activeName === 'third') this.$refs.assignSale.handleAssign();
            else if (this.activeName === 'sixth') this.$refs.coach.handleAssign();
        },
        handleClose() {
            this.is_collapse = false;
            this.addSearch = false;
        },
        headListen(data) {
            this.clientIds = data.map(el => el.id);
            this.clients = data;
        },
        removeOption(val, key) {
            console.log(val, key);
            for (const prop in this.form) {
                if (prop === key) {
                    this.form[prop] = null;
                }
            }
        },
        validSingleSelect() {
            if (this.clientIds.length > 1) {
                $ele.$message.warning(this.$t('Common.message.onlyoperationone'));
            } else if (this.clientIds.length < 1) {
                $ele.$message.warning(this.$t('Common.message.Pleaseselectonetodo'));
            } else return true;
        },
        // 导入
        handleExport() {
            if (this.$$filterPermission('客户-会员列表的导入-会员列表的导入')) {
                const type = this.activeName === 'first' ? 1 : 2;
                this.$router.push({
                    name: 'Upload',
                    query: {
                        isMember: 'member',
                        type: type,
                    },
                });
            } else {
                this.$router.push('/403');
            }
        },
        // 会员体测
        measurement() {
            if (!this.clients.length) return $ele.$message.warning(this.$t('Common.message.Pleaseselectonetodo'));
            else if (this.clients.length > 1) return $ele.$message.warning(this.$t('Common.message.onlyoperationone'));
            this.$router.push({
                name: 'Measurement',
                query: {
                    client: this.clients[0].id,
                },
            });
        },
    },
    created() {
        if (this.$route.query.activeName) this.activeName = this.$route.query.activeName;
        if (this.$route.query.clientId) this.clientId = this.$route.query.clientId;
        this.fetchTag();
        this.fetchConstant();
        this.fetchStore();
    },
    directives: {
        clickoutside: {
            bind: function (el, binding) {
                function documentHandler(e) {
                    if (el.contains(e.target)) {
                        return false;
                    }
                    if (binding.expression) {
                        binding.value(e);
                    }
                }
                el.vueClickOutside = documentHandler;
                document.addEventListener('click', documentHandler);
            },
            unbind: function (el) {
                document.removeEventListener('click', el.vueClickOutside);
                delete el.vueClickOutside;
            },
        },
    },
};
</script>

<style lang="scss">
.material-index {
    .image {
        max-height: 46px;
    }
    .el-button-ui {
        border: none;
        line-height: 0;
        padding: 0px;
        margin-right: 0px;
        font-size: 16px;
    }
    .common-operation {
        position: absolute;
        top: 100px;
        right: 46px;
        float: right;
        z-index: 3;
        min-height: 34px;
    }
    .top-icon {
        font-size: 25px;
        min-height: 20px;
    }
    .filter_panel {
        position: absolute;
        right: 0;
        top: 0px;
        z-index: 99;
        width: 310px;
        border-left: 1px solid #cfd4db;
        box-shadow: 0 3px 3px #ccc;
        top: 100px;
        border-top: 2px solid #f3f4f6;
        background: #f6f6f6;
        padding: 0;
        margin-top: 38px;
        height: 650px;
        // height: 100%;

    }
    .filter-show_all {
        padding: 20px;
        background: #fff;
    }
    .filter_panel1 {
        position: absolute;
        right: 0;
        top: 0px;
        left: -301px;
        z-index: 99;
        width: 300px;
        border-left: 1px solid #cfd4db;
        box-shadow: 0 3px 3px #ccc;
        top: -38px;
        border-top: 2px solid #f3f4f6;
        background: #f6f6f6;
        padding: 0;
        margin-top: 38px;
    }
    .search {
        position: relative;
        -webkit-transition: -webkit-transform 0.3s;
        transition: -webkit-transform 0.3s;
        transition: transform 0.3s;
        transition: transform 0.3s, -webkit-transform 0.3s;
        transition: transform 0.3s, -webkit-transform 0.3s;
        float: right;
        right: 5px;
        top: 20px;
        z-index: 2;
        padding: 0;
        margin: 0;
    }
    .box-a1 {
        padding: 10px 15px;
        border-radius: 4px;
        margin-bottom: 15px;
        border: 1px solid #e6e6e6;
        background: #fafafa;
        position: relative;
        p {
            margin: 0;
            font-size: 14px;
            color: #212121;
            margin-top: 15px;
        }
        p:first-child {
            margin-top: 0;
            font-size: 12px;
            color: #666;
        }
        .filter-tags-flex {
            display: inline-block;
            p {
                margin: 0;
                font-size: 14px;
                color: #212121;
                margin-top: 15px;
            }
        }
    }
    .filter-pages-fixed {
        background: #fff;
    }
    .delete-property {
        top: 6px;
        right: 6px;
        color: #697a8e;
        font-size: 16px;
        position: absolute;
    }
}
.pages-height {
    min-height: 100%;
}
</style>
